import styled from 'styled-components';
import { blue } from '../variables';

export default styled.hr`
    border: none;
    border-top: solid 1px ${blue};
    height: 1px;
`;
